import _ from "lodash";
import { fetch } from "src/services/apollo-fetch";
import { Mutation, Query } from "../_api";

async function fetchReceiptLogs(data) {
    const response = await fetch.query({
        query: Query.receiptLogSearch,
        variables: data,
    });
    return response.data.receiptLogs.receiptLogs;
}

export default {
    async fetchQuote(context, id) {
        const response = await fetch.query({
            query: Query.quote,
            variables: { id },
        });
        return response.data.quote;
    },
    async fetchQuotes({ commit }) {
        const response = await fetch.query({
            query: Query.quotes,
        });
        commit("setQuotes", response.data.quotes);
    },
    async fetchMaterialTypes() {
        const response = await fetch.query({
            query: Query.materialTypes,
        });
        return response.data.materialTypes;
    },
    searchReceiptLogs: _.debounce(
        async (context, data) => {
            return await fetchReceiptLogs({
                limit: 50,
                search: data.search,
                customerID: data.customerID,
            });
        },
        500, // 500ms
        { leading: true, trailing: true },
    ),
    async addQuote({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addQuote,
                variables: { input: data },
            },
            { showToast: false },
        );
        commit("addQuote", response.data.addQuote);
    },
    async deleteQuote({ commit }, id) {
        await fetch.mutate(
            {
                mutation: Mutation.deleteQuote,
                variables: { id },
            },
            { message: `Quote #${id} deleted.` },
        );
        commit("deleteQuote", id);
    },
    async updateQuoteStatus({ commit }, { id, status }) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.updateQuoteStatus,
                variables: { id, status },
            },
            { showToast: false },
        );
        commit("updateQuote", response.data.updateQuoteStatus);
    },
};
